import { useEffect, useMemo } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Question, State } from 'src/@types/generalEnquete';
import RHFDatePickers from 'src/components/react-hook-form/RHFDatePickers';
import { useEnqueteAnswerValidator } from 'src/features/general/enquete-answer/components/tab-containers/type-general-question/components/tabs/question-and-answer/hooks/useEnqueteAnswerValidator';
import { dateFormat } from 'src/utils/formatDateTime';
//useEnqueteAnswerHandleOnChangeをインポートする
import { useEnqueteAnswerHandleOnChange } from '../hooks/useEnqueteAnswerHandleOnChange';

type EnqueteAnswerPeriodFormProps = {
  question: Question;
  index: number;
  methods: UseFormReturn;
  languageCode?: string;
  questionState?: State;
  //ルールチェックしないフラグ
  noCheckRule?: boolean
};

const EnqueteAnswerPeriodForm = ({ question, index, methods, languageCode, questionState, noCheckRule }: EnqueteAnswerPeriodFormProps) => {
  const { t } = useTranslation();

  const { rulesEnqueteAnswerStartDate, rulesEnqueteAnswerEndDate } = useEnqueteAnswerValidator(
    methods as UseFormReturn,
    question,
    languageCode,
    questionState,
  );
  const memolizedRuleStartDate = useMemo(() => rulesEnqueteAnswerStartDate, [rulesEnqueteAnswerStartDate]);
  const memolizedRuleEndDate = useMemo(() => rulesEnqueteAnswerEndDate, [rulesEnqueteAnswerEndDate]);
  //handleOnChangeDateを取得する
  const { handleOnChangeDate } = useEnqueteAnswerHandleOnChange();

  // 質問表示状態が変ったらルールをスイッチする。
  useEffect(() => {
    if (methods && question.answerItem) {
      if (methods?.getValues(question.questionItem[0].id) !== undefined) {
        const stateRule = questionState === 'disabled' || questionState === 'hidden' || noCheckRule ? {} : memolizedRuleStartDate;
        const value = methods?.getValues(question.questionItem[0].id) ?? '';
        methods?.control.unregister(question.questionItem[0].id);
        methods?.control.register(question.questionItem[0].id, stateRule);
        methods?.setValue(question.questionItem[0].id, value);
        methods?.trigger(question.questionItem[0].id);
      }
      if (methods?.getValues(question.questionItem[1].id) !== undefined) {
        const stateRule = questionState === 'disabled' || questionState === 'hidden' || noCheckRule ? {} : memolizedRuleEndDate;
        const value = methods?.getValues(question.questionItem[1].id) ?? '';
        methods?.control.unregister(question.questionItem[1].id);
        methods?.control.register(question.questionItem[1].id, stateRule);
        methods?.setValue(question.questionItem[1].id, value);
        methods?.trigger(question.questionItem[1].id);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questionState]);

  return (
    <RHFDatePickers
      openDateName={question.questionItem[0].id}
      closeDateName={question.questionItem[1].id}
      openDateLabel={t('enqueteCreate.startDate', { lng: languageCode })}
      closeDateLabel={t('enqueteCreate.endDate', { lng: languageCode })}
      openDateRules={questionState === 'disabled' || questionState === 'hidden' || noCheckRule ? {} : memolizedRuleStartDate}
      closeDateRules={questionState === 'disabled' || questionState === 'hidden' || noCheckRule ? {} : memolizedRuleEndDate}
      control={methods?.control}
      defalutCloseDate={question.answerItem !== undefined && question.answerItem[1]?.value ? new Date(String(question.answerItem[1].value)) : null}
      defalutOpenDate={question.answerItem !== undefined && question.answerItem[0]?.value ? new Date(String(question.answerItem[0].value)) : null}
      inputFormat={dateFormat}
      sx={{ width: 190 }}
      mask={'____/__/__'}
      //開始日日付変更時の変更イベント
      openDateOnChange={(e) => {
        handleOnChangeDate(e, question, index, 0);
      }}
      //終了日日付変更時の変更イベント
      closeDateOnChange={(e) => {
        handleOnChangeDate(e, question, index, 1);
      }}
      //開始日日付キーボード入力変更時の変更イベント
      openDateOnInput={(e) => {
        handleOnChangeDate(e, question, index, 0);
      }}
      //終了日日付キーボード入力変更時の変更イベント
      closeDateOnInput={(e) => {
        handleOnChangeDate(e, question, index, 1);
      }}
      openDateDisabled={questionState === 'disabled'}
      closeDateDisabled={questionState === 'disabled'}
    />
  );
};
export default EnqueteAnswerPeriodForm;
